export default "__VITE_ASSET__fohKc5rQSM63MVLIch$pCw__"